import {Component, inject, ChangeDetectionStrategy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {VwuiAngularModule, VwuiModalConfig, VwuiModalRef} from '@bvgo-ict/vwui-angular';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';

import {ToastService} from '../../services';
import {ProjectNoteService} from '../../services/project-note/project-note.service';

export interface AddProjectNoteModalData {
    projectId: number;
}

@Component({
    selector: 'app-add-project-note-modal',
    templateUrl: './add-project-note-modal.component.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, FormsModule, TranslatePipe, VwuiAngularModule]
})
export class AddProjectNoteModalComponent {
    public readonly modalRef = inject(VwuiModalRef);
    public readonly modalConfig = inject<VwuiModalConfig<AddProjectNoteModalData>>(VwuiModalConfig);
    private readonly projectNoteService = inject(ProjectNoteService);
    private readonly toastService = inject(ToastService);
    private readonly translateService = inject(TranslateService);

    public message = '';
    public isSaving = false;

    public canSave(): boolean {
        return this.message.trim().length > 0 && !this.isSaving;
    }

    public save(): void {
        if (!this.canSave()) {
            return;
        }

        this.isSaving = true;
        this.projectNoteService.create(this.modalConfig.data.projectId, this.message.trim()).subscribe({
            next: () => {
                this.toastService.openSuccess(this.translateService.instant('PROJECT_NOTES.toast.saved'));
                this.modalRef.close(true);
            },
            error: (error) => {
                console.error(error);
                this.isSaving = false;
                this.toastService.openError(error.status ?? 0, this.translateService.instant('ERRORS.note_not_saved'));
            }
        });
    }
}
